import { useState, useCallback } from 'react';
import { useContentGenerationStore } from '../Generate/components/ProductTable/store';

/**
 * Hook that manages the Add Products Modal state using plain React state.
 * This prevents any interference with the main table's zustand store and query cache.
 */
export const useAddProductsModalStore = () => {
  const [modalSelectedItems, setModalSelectedItems] = useState<Set<string>>(new Set());

  const toggleModalItem = useCallback((retailerSku: string) => {
    setModalSelectedItems((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(retailerSku)) {
        newSet.delete(retailerSku);
      } else {
        newSet.add(retailerSku);
      }
      return newSet;
    });
  }, []);

  const setModalSelectedItemsHandler = useCallback((items: Set<string>) => {
    setModalSelectedItems(items);
  }, []);

  const clearModalSelection = useCallback(() => {
    setModalSelectedItems(new Set());
  }, []);

  const syncWithMainStore = useCallback(() => {
    const mainStore = useContentGenerationStore.getState();

    const mergedSelections = new Set([...mainStore.selectedItems, ...modalSelectedItems]);

    mainStore.setSelectedItems(mergedSelections);
  }, [modalSelectedItems]);

  return {
    modalSelectedItems,
    toggleModalItem,
    setModalSelectedItems: setModalSelectedItemsHandler,
    clearModalSelection,
    syncWithMainStore
  };
};
